import { ComputedRef, Ref } from 'vue'
import { DropDownMenuItemProps } from 'frontcore/views/drop-down/domain/types'
import { RemoteFiltersValue } from 'frontcore/presentation/remote-filters/domain/remote-filters-value'

export enum RemoteFiltersFieldType {
  SELECT_SINGLE = 1,
  SELECT_SINGLE_REMOTE,
  SELECT_MULTIPLE,
  SELECT_MULTIPLE_REMOTE,
  SWITCH,
  DATE,
  DATE_RANGE,
  SEARCH,
  SEGMENTED_BUTTON,
}

export type RemoteFiltersConfiguration = {
  componentProps: Record<string, unknown>
  defaultOption?: string | string[] | number | number[] | boolean | Date | Date[]
  filterId: string
  filterMap: string
  filterType: RemoteFiltersFieldType
  label: string
  modules?: string[]
  options: DropDownMenuItemProps[]
  relatedFilters: string[]
  required: boolean
  reloadFiltersWhenUpdateValue: boolean
}

export type RemoteFiltersChip = DropDownMenuItemProps & Pick<RemoteFiltersConfiguration, 'filterId' | 'filterType' | 'required'>

export type RemoteFiltersStore = {
  clearChanges: () => void
  commitChanges: () => void
  getRemoteFiltersValue: (filterId: string) => RemoteFiltersValue | undefined
  isFilterChanged: (configuration: RemoteFiltersConfiguration) => boolean
  initialFetch: () => Promise<void>
  moduleRemoteFilters: Ref<Record<string, RemoteFiltersValue>>
  moduleRemoteFiltersConfigurations: ComputedRef<RemoteFiltersConfiguration[]>
  remoteFilters: Ref<Record<string, RemoteFiltersValue>>
  remoteFiltersChips: ComputedRef<Record<string, RemoteFiltersChip[]>>
  remoteFiltersConfigurations: Ref<RemoteFiltersConfiguration[]>
  queryParameters: ComputedRef<Record<string, string>>
  setRemoteFiltersValue: (filterId: string, value: RemoteFiltersValue) => void
  stagedFilters: Ref<Record<string, RemoteFiltersValue>>
  remoteFilterStoreID: string
  searchText: Ref<string>
  buildOptionsFromRemoteRelatedValues: (filterId: string, remoteFilterValue: RemoteFiltersValue, filtersConfigurations: RemoteFiltersConfiguration[]) => void
  isFilterActiveInModule: (configuration: RemoteFiltersConfiguration) => boolean
}

export type RemoteFiltersStoreConfiguration = {
  id: string
  extra: Record<string, unknown>
}
